import { render, staticRenderFns } from "./UserBannedModalHandler.vue?vue&type=template&id=dcb024c4&scoped=true&"
import script from "./UserBannedModalHandler.vue?vue&type=script&lang=js&"
export * from "./UserBannedModalHandler.vue?vue&type=script&lang=js&"
import style0 from "./UserBannedModalHandler.vue?vue&type=style&index=0&id=dcb024c4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb024c4",
  null
  
)

export default component.exports